/**
 * Created by anthony on 7/3/14.
 */


var childrenModel = angular.module('childrenModel', []);
childrenModel.factory('ChildrenModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory, BaseModel) {
    var ChildrenModel = function(familyID){
        this.familyID = familyID;
        this.dataProperty = "children";
        this.endpoint = "/children"; 
        this.primaryKey = "recordID";
        //this.data = angular.copy(this.get());
    }
    ChildrenModel.prototype = new FamilyModelFactory();
    ChildrenModel.prototype.parent = FamilyModelFactory.prototype;
    ChildrenModel.prototype.new = function(familyIndex)
    {
        return ApplicationService.getFamilyData().children.push (
            {
                Chi_Aid: "", Chi_Aid_Amt: "", Chi_Complete: "", Chi_DOB: "", Chi_First_Name: "", Chi_Gender: "",
                Chi_Holds: "", Chi_Last_Name: "", Chi_Present_Grade: "", Chi_Present_School: "", Chi_Residence: "",
                Chi_School_Expense: "", Chi_Tuition: "", Chi_Tuition_Amt: "", xChi_Aid: "", xChi_Aid_Amt: "",  
                xChi_DOB: "", xChi_First_Name: "", xChi_Gender: "", xChi_Last_Name: "", xChi_Present_Grade: "", 
                xChi_Present_School: "", xChi_Residence: "", xChi_Tuition: "", xChi_Tuition_Amt: "", active: true
            }
        ) - 1;
    }

    ChildrenModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + this.familyID + "/children/" + id, data, instance);
    }

    ChildrenModel.prototype.post = function(id, data, instance)
    {
        return AbstractModelService.post("/api/family/" + id + "/children", data, instance);
    }

    ChildrenModel.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge("/api/family/" + id + "/children/" + data.recordID, data, instance);
    }
    /*
    ChildrenModel.prototype.updateData = function() //Abstract
    {
        if (!ApplicationService.isFamilyTwoSituation())
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else if (ApplicationService.getAwardData().family[0].data[0].familyID == this.familyID)
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);

        this.data = angular.copy(this.get());
    }
    */
    return ChildrenModel;
});

childrenModel.service('ChildrenModelService', function(ChildrenModelFactory){
    var childrenModel = new ChildrenModelFactory();
    return childrenModel;
});